module.exports = __webpack_public_path__ + "static/media/select_program.a29bba9c.jpg";